<div class="about-section">
  <div class="container">
    <div class="row justify-content-center">
      <h2 class="heading">About Us</h2>
    </div>
    <div class="row justify-content-center info-cards">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="info-card">
          <h3>Legal Name</h3>
          <p>Zenith Guard Private Limited</p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="info-card">
          <h3>Registered Address</h3>
          <p>4th Floor,Majestic Signia,405,Plot No.A-27,Block A, Industrial Area, Sector 62,Noida,Uttar Pradesh 201309</p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="info-card">
          <h3>Office Address</h3>
          <p>4th Floor,Majestic Signia,405,Plot No.A-27,Block A, Industrial Area, Sector 62,Noida,Uttar Pradesh 201309</p>
        </div>
      </div>
    </div>
  </div>
</div>
